module.exports = __webpack_public_path__ + "static/media/svg-slogan.7136d6c7.svg";